var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromoCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.9985 18.038L31.9985 14.7531C31.9985 14.3077 31.7162 13.8901 31.3055 13.7788C29.8937 13.4169 28.9184 12.025 28.8927 10.4382C28.8927 8.87924 29.8681 7.48735 31.3055 7.09761C31.7162 6.98626 32.0242 6.59652 31.9985 6.12327L31.9985 2.78269C31.9985 2.11457 31.7418 1.50213 31.3312 1.05672C30.9205 0.611307 30.3557 0.332933 29.7397 0.332933L8.42105 0.332929L8.42105 20.5435L29.7397 20.5435C30.9975 20.4599 31.9985 19.3743 31.9985 18.038Z",
    fill: "#E2E8F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.655832 13.8066C0.28099 13.918 -0.000138691 14.3077 -0.000138735 14.8088L-0.000153327 18.0937C-0.000153444 19.4299 0.936949 20.5435 2.06148 20.5435L8.4209 20.5435L8.4209 0.332932L2.06148 0.332931C0.936951 0.332931 -0.000151872 1.44645 -0.000151989 2.78269L-0.000137971 6.06759C-0.00013801 6.513 0.28099 6.95843 0.655832 7.06978C1.99121 7.43168 2.90488 8.79575 2.90488 10.4104C2.90488 12.0807 1.99121 13.4447 0.655832 13.8066Z",
    fill: "#E2E8F3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23154",
    x: 10.1055,
    y: 20.5439,
    width: 1.68421,
    height: 3.36842,
    transform: "rotate(-180 10.1055 20.5439)",
    fill: "#A5B4CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23157",
    x: 10.1055,
    y: 15.4912,
    width: 1.68421,
    height: 4.21053,
    transform: "rotate(-180 10.1055 15.4912)",
    fill: "#A5B4CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23158",
    x: 10.1055,
    y: 9.59668,
    width: 1.68421,
    height: 4.21053,
    transform: "rotate(-180 10.1055 9.59668)",
    fill: "#A5B4CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23156",
    x: 10.1055,
    y: 3.70166,
    width: 1.68421,
    height: 3.36842,
    transform: "rotate(-180 10.1055 3.70166)",
    fill: "#A5B4CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23159",
    x: 12.6318,
    y: 15.4912,
    width: 15.1579,
    height: 2.52632,
    fill: "#CFD7E8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23160",
    x: 12.6318,
    y: 11.2808,
    width: 10.1053,
    height: 2.52632,
    fill: "#CFD7E8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoCode);
export default __webpack_public_path__ + "static/media/promo-code.b883e4afc6b13f30ae1bdb3d84b41242.svg";
export { ForwardRef as ReactComponent };